module.exports = __webpack_public_path__ + "img/pos_tag_800.8ea30341.png";